import { AppLogoLink, Header } from "@gearbox-protocol/ui-kit";
import { ConnectKitButton } from "connectkit";
import { Navigation, NavigationMobile } from "./navigation";

export function HeaderLayout() {
  return (
    <Header
      logo={<AppLogoLink appName="Governance" />}
      navigation={<Navigation />}
      mobileMenuContent={<NavigationMobile />}
      actions={<ConnectKitButton />}
    />
  );
}
